module.exports = __webpack_public_path__ + "img/23_93.40689885.png";